<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import Blok from '../blok.svelte';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			id: string;
			body: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div id={content.id} use:editable={content}>
	{#each content.body as block}
		<Blok content={block} />
	{/each}
</div>
